module.exports = __webpack_public_path__ + "fonts/Lato-Regular.4b3ec3d.woff2";